import React, { Component } from 'react';
import { Radio, Icon } from 'antd';
import {
  FlexDrawer, FlexOptionGroup, DrawerHeader, DrawerContent,
} from './styles';

class RelocatableDrawer extends Component {
  state = {
    direction: 'right',
  }

  handleChangeSwapDirection = (event) => {
    this.setState({ direction: event.target.value });
  }

  render() {
    const { drawerComponent, ...rest } = this.props;
    const { direction } = this.state;
    return (
      <FlexDrawer
        width={(direction === 'bottom') ? '100%' : 400}
        placement={direction}
        mask={false}
        maskClosable
        destroyOnClose
        {...rest}
      >
        <DrawerHeader top="0">
          <FlexOptionGroup size="small" onChange={this.handleChangeSwapDirection}>
            <Radio.Button value="left">
              <Icon type="left-square" />
            </Radio.Button>
            <Radio.Button value="bottom">
              <Icon type="down-square" />
            </Radio.Button>
            <Radio.Button value="right">
              <Icon type="right-square" />
            </Radio.Button>
          </FlexOptionGroup>
        </DrawerHeader>
        <DrawerContent>
          {drawerComponent}
        </DrawerContent>
      </FlexDrawer>
    );
  }
}

export default RelocatableDrawer;
